export default function sortTable() {
  const isShowingDifferences = document.querySelector('#diff').checked
  const rows = document.querySelectorAll('.compare-body__row[data-index]')
  const rowsWithDifferences = [...document.querySelectorAll('.compare__different')]

  if (isShowingDifferences) {
    rowsWithDifferences
      .reverse()
      .forEach(row => $(row).insertAfter('tbody tr:nth-child(1)'))
  } else {
    rows.forEach(row => {
      const index = row.attributes['data-index'].value
      $(row).insertAfter(`tbody tr:nth-child(${index})`)
    })
  }
}
